/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

export type StatusActionDtoType = typeof StatusActionDtoType[keyof typeof StatusActionDtoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StatusActionDtoType = {
  OPEN_URL: 'OPEN_URL',
  RETRY: 'RETRY',
  OPEN_SCREEN: 'OPEN_SCREEN',
} as const;
